//ButtonControlView

import BaseControlView from 'BaseControlView';
import template from 'common-visuals/control-button.ejs';
import eventBus         from 'EventBus';
import constants        from "Constants";

//=====================================================================
//
// An instance of this view represents a pushbutton control
//
// Lou Mauget, November 2015
//
//=====================================================================
class ButtonControlView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );

            this.template = template;

            this.tagName = 'div';
            this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
            this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
            return this;
        }
    
        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'ButtonControlView';
        }
}

export default ButtonControlView;
